export enum KeyCodes {
    Enter = 'Enter'
}
